<template>
  <section class="tv-screen masthead">
    <div class="container-fluid">
      <div class="row tv-screen-header py-5 mx-lg-2 align-items-center">
        <div class="col-lg-8">
          <h1>Student Enquiry Form</h1>
        </div>
      </div>
      <div class="row w-100 m-md-5  py-5 justify-content-center align-items-start full-sef" style="">
        <div class="col-md-6 col-12 text-center">
          <img src="@/assets/imgs/introduction.png" alt="" class="mt-2" width="500" height="500"/>
        </div>
        <div class="col-md-6 col-12 ">

          <form class="d-flex mr-md-5 flex-column align-items-center justify-content-center p-2 my-form rounded-lg"
            @submit.prevent="handleSubmit">
            <div class="row w-100" >
              <div class="col-md-6 my-input">
                <label for="name">Name <span class="text-danger">*</span></label>
                <b-form-input id="name" size="sm" required v-model="form.name" 
                  class="w-100 rounded " style="height: 70% !important;"></b-form-input>
              </div>
              <div class="col-md-6 my-input">
                <label for="email">Email Address <span class="text-danger">*</span></label>
                <b-form-input id="email" required size="sm" v-model="form.email" 
                  class="w-100 rounded " style="height: 70% !important;"></b-form-input>
              </div>
            </div>

            <div class="row w-100" >
              <div class="col-md-6 my-input">
                <label for="mobileNumber">Mobile Number <span class="text-danger">*</span></label>
                <b-form-input id="mobileNumber" required size="sm" v-model="form.mobileNumber"
                  class="w-100 rounded "
                  style="height: 70% !important;"></b-form-input>
              </div>
              <div class="col-md-6 my-input">
                <label for="state">State <span class="text-danger">*</span></label>
                <b-form-select id="state" required size="sm" v-model="form.state" :options="myStates"
                  class="w-100 rounded " style="height: 70% !important;"
                  @change="handleStateChange"></b-form-select>
              </div>
            </div>

            <div class="row w-100" >
              <div class="col-md-6 my-input">
                <label for="city">City <span class="text-danger">*</span></label>
                <b-form-select id="city" required size="sm" v-model="form.city" :disabled="!form.state"
                  :options="cityOptions" class="w-100 rounded "
                  style="height: 70% !important;"></b-form-select>
              </div>
              <div class="col-md-6 my-input">
                <label for="course">Course <span class="text-danger">*</span></label>
                <b-form-select id="course" required size="sm" v-model="form.course" :options="courseOptions"
                  class="w-100 rounded " style="height: 70% !important;"></b-form-select>
              </div>
            </div>

            <div class="row w-100" >
              <div class="col-md-6 my-input">
                <label for="specialization">Specialization <span class="text-danger">*</span></label>
                <b-form-select id="specialization" required size="sm" v-model="form.specialization"
                  :options="specializationOptions" class="w-100 rounded "
                  style="height: 70% !important;"></b-form-select>
              </div>
              <div class="col-md-6 my-input">
                <label for="interestedCountry">Interested Country <span class="text-danger">*</span></label>
                <b-form-input id="interestedCountry" required size="sm" v-model="form.interestedCountry"
                  class="w-100 rounded "
                  style="height: 70% !important;"></b-form-input>
              </div>
            </div>

            <div class="row w-100" >
              <div class="col-md-6 my-input">
                <label for="highestQualification">Highest Qualification <span class="text-danger">*</span></label>
                <b-form-input id="highestQualification" required size="sm" v-model="form.highestQualification"
                  class="w-100 rounded"
                  style="height: 70% !important;"></b-form-input>
              </div>
              <div class="col-md-6 my-input">
                <label for="budget">Budget <span class="text-danger">*</span></label>
                <b-form-input id="budget" required size="sm" v-model="form.budget"
                  class="w-100 rounded" style="height: 70% !important;"></b-form-input>
              </div>
            </div>

            <div class="w-100 py-3 d-flex justify-content-center">
              <button type="submit" class="btn rounded" style="background-color: #fe6d01; color: white">
                Submit
              </button>
            </div>
          </form>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import homeServices from "@/apiServices/homeServices";
// import { jsonData } from "../partials/Cities";
import stateCity from "../partials/stateCity";
import {
  // stateOptions,
  courseOptions,
  specializationOptions,
  // cityOptions,
} from "../partials/sefDetails";
import { LMS_API } from "@/config/index";
import axios from "axios";

export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,

        course: null,
        specialization: null,
        interestedCountry: "",
        highestQualification: "",
        budget: "",
        // jsonData
      },
      // stateOptions,
      courseOptions,
      specializationOptions,
      cityOptions: [],
      myStates: [],
    };
  },
  methods: {
    info() { },
    stateOptions() {
      return stateCity.map((stateCity) => stateCity.state);
    },
    async getMyStates() {
      try {
        const res = await axios.get(LMS_API + "/form-webhook/master/states");
        this.myStates = res.data.data.map((state) => ({
          value: state.state_id,
          text: state.name,
        }));
      } catch (error) {
        console.log(error);
      }
    },
    async handleStateChange() {
      try {
        // Make an API call to fetch cities based on the selected state_id
        const response = await axios.get(
          LMS_API + `/form-webhook/master/cities/${this.form.state}`
        );
        this.cityOptions = response.data.data.map((city) => ({
          value: city.city_id,
          text: city.name,
        }));
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    },
    geCityOptions() {
      let currentStateCity = stateCity.find(
        (stateCity) => stateCity.state === this.form.state
      );

      this.cityOptions = currentStateCity.cities;
    },
    async handleSubmit(e) {
      try {
        e.preventDefault();

        const requestData = {
          full_name: this.form.name,
          email: this.form.email,
          dial_code_id: "12183",
          country_dial_code: "+91",
          mobile: this.form.mobileNumber,
          source: "Sef Form",
          field_values: [
            { name: "Budget", value: this.form.budget },
            {
              name: "Highest Qualification",
              value: this.form.highestQualification,
            },
            { name: "Expected Salary", value: this.form.course },
            { name: "Highest Qualification", value: this.form.specialization },
            { name: "Interested Country", value: this.form.interestedCountry },
          ],
          state: this.form.state,
          city: this.form.city,
          category: "Student",
          ls_id: 2,
          m_id: 42
        };

        const response = await axios.post(
          `${LMS_API}/form-webhook/lead`,
          requestData
        );
        if (response.data.status) {
          this.resetForm();
          this.formSubmitToast();
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
    formSubmitToast() {
      this.$bvToast.toast(`The form has been submitted successfully.`, {
        title: "Form Submitted",
        autoHideDelay: 5000,
        solid: true,
      });
    },
    resetForm() {
      this.form = {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
        course: null,
        specialization: null,
        interestedCountry: "",
        highestQualification: "",
        budget: "",
      };
    },
  },
  beforeMount() {
    this.getMyStates();
  },
};
</script>

<style>
.list-inline {
  padding: 0;
  margin: 0;
  list-style-type: none;
  display: flex;
}

.list-inline li:not(:first-child):before {
  content: "";
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #fff;
  border-radius: 50%;
  margin: 0px 20px;
}

.yottie-widget-feed-section-pagination .swiper-pagination-bullet-active {
  background-color: var(--primary) !important;
  color: #fff !important;
}

.yottie-widget-video-classic {
  border: 2px solid #d0d0d0 !important;
  padding: 10px !important;
  border-radius: 10px !important;
}

span.yottie-widget-feed-section-pagination-bullet {
  height: 40px !important;
  width: 40px !important;
  line-height: 1.6 !important;
  font-size: 18px !important;
}

.custom-input {
  border: none;
  outline: 0 !important;
  border-bottom: 1px solid lightgrey;
  box-shadow: none;
  transition: all 0.5s;
}

.custom-input:focus {
  box-shadow: none !important;
  border-bottom: 1px solid #fe6d01;
}

.my-form {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.full-sef{
  height: 800px;
}
.my-input{
  margin-bottom: 1.7rem;
}

@media screen and (max-width: 768px) {
  .full-sef{
  height: 100% !important;
}
.my-form{
  width: 100% !important;
}
}
</style>



// WEBPACK FOOTER //
// src/components/pages/sefApi.vue